/**
 * Countdown Hook
 *
 * Displays a live countdown in seconds based on a `data-expires-at` ISO 8601 timestamp.
 * Hides the row when the countdown reaches zero.
 */

const INTERVAL_MS = 1000

const remainingSeconds = (expiresAt: string): number =>
  Math.max(0, Math.round((new Date(expiresAt).getTime() - Date.now()) / 1000))

const updateEl = (el: HTMLElement, expiresAt: string): boolean => {
  const seconds = remainingSeconds(expiresAt)
  el.textContent = `${seconds}s`

  if (seconds <= 0) {
    el.closest('tr')?.remove()
    return false
  }

  return true
}

export const Countdown = {
  mounted(this: { el: HTMLElement; timer?: number }) {
    const expiresAt = this.el.dataset.expiresAt ?? ''
    updateEl(this.el, expiresAt)

    this.timer = window.setInterval(() => {
      if (!updateEl(this.el, expiresAt)) {
        window.clearInterval(this.timer)
      }
    }, INTERVAL_MS)
  },

  destroyed(this: { timer?: number }) {
    if (this.timer) {
      window.clearInterval(this.timer)
    }
  }
}
